import instance from "./instance";
export const findAll = () => {
    return instance.get(`/videos`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
};
